export const STAKEHOLDERS = ["Employer", "Academy", "Government"]
export const INSTRUCTOR = 'Instructor'
export const EMPLOYER = 'Employer'
export const ACADEMY = 'Academy'
export const GOVERNMENT = 'Government'
export const SUPER_ADMIN = "Super Administrator"
export const SUPPORT = "Support"
